import useIsReferrerAdmin from './useIsReferrerAdmin';
import useIsReferrer from './useIsReferrer';
import ConfigLink from 'vl-core/config.link';

const useAdminPageURL = () => {
  const isReferrerAdmin = useIsReferrerAdmin();
  const isReferrer = useIsReferrer();

  const getAppointmentBookingPageURL = () => {
    if (isReferrer) {
      return ConfigLink.ReferrerAppointmentBooking;
    }

    if (isReferrerAdmin) {
      return ConfigLink.ReferrerAdminAppointmentBooking;
    }

    return ConfigLink.AdminAppointmentBooking;
  };

  const getScheduleCaseReviewPageURL = () => {
    if (isReferrer) {
      return ConfigLink.ReferrerScheduleCaseReview;
    }

    if (isReferrerAdmin) {
      return ConfigLink.ReferrerAdminScheduleCaseReview;
    }

    return ConfigLink.AdminScheduleCaseReview;
  };

  const getAppointmentsPageURL = () => {
    if (isReferrer) {
      return ConfigLink.ReferrerAppointments;
    }

    if (isReferrerAdmin) {
      return ConfigLink.ReferrerAdminAppointments;
    }

    return ConfigLink.Appointments;
  };

  const getCasesPageURL = () => {
    if (isReferrer) {
      return ConfigLink.ReferrerCases;
    }

    if (isReferrerAdmin) {
      return ConfigLink.ReferrerAdminCases;
    }

    return ConfigLink.Cases;
  };

  const getPatientsPageURL = () => ConfigLink.Patients;

  return {
    getAppointmentsPageURL,
    getAppointmentBookingPageURL,
    getScheduleCaseReviewPageURL,
    getCasesPageURL,
    getPatientsPageURL
  };
};

export default useAdminPageURL;
